<template>
  <header class="site-header">
    <nav class="navbar navbar-expand-lg padding-nav static-nav">
      <div class="container">
        <a class="navbar-brand" href="/">
          <img
            src="/fe/asset/img/logo.png"
            alt="logo"
            style="max-width: 70px"
          />
        </a>
        <div class="collapse navbar-collapse">
          <ul class="navbar-nav mx-auto">
            <Menu />
          </ul>
        </div>
        <!-- <ul class="social-icons darkcolor social-icons-simple d-lg-inline-block d-none animated fadeInUp" data-wow-delay="300ms">
                    <li><a href="#." class="facebook"><i class="fab fa-facebook-f"></i> </a> </li>
                    <li><a href="#." class="twitter"><i class="fab fa-twitter"></i> </a> </li>
                    <li><a href="#." class="linkedin"><i class="fab fa-linkedin-in"></i> </a> </li>
                </ul> -->
      </div>
      <!--side menu open button-->
      <a
        href="javascript:void(0)"
        class="d-inline-block sidemenu_btn"
        id="sidemenu_toggle"
      >
        <span class="gradient-bg"></span> <span class="gradient-bg"></span>
        <span class="gradient-bg"></span>
      </a>
    </nav>
    <!-- side menu -->
    <SideMenu />
    <!-- End side menu -->
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Menu from "@/components/layouts/navbar/Menu.vue";
import SideMenu from "@/components/layouts/navbar/SideMenu.vue";

export default defineComponent({
  name: "NavbarBasic",
  components: {
    Menu,
    SideMenu,
  },
  setup() {},
});
</script>
